// React
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Modal,
  ModalBody,
  CardHeader,
  ModalFooter,
} from 'reactstrap';

// Helpers
import { APIClient } from '../../../../../../helpers/api_helper';

export const ModalProposalDetails = ({
  isOpen,
  toggle,
  history,
  hashidProposal,
}) => {
  const [proposal, setProposal] = useState();

  const api = new APIClient();

  const convertDateToBrazilFormat = (date) => {
    if (date !== null) {
      const [year, month, day] = date.split('-');

      return [day, month, year].join('/');
    }
    return null;
  };

  const getProposalsById = async (hash) => {
    const proposal = await api.get(`/proposal/${hash}`);

    if (proposal) {
      setProposal(proposal);
    }
  };

  useEffect(() => {
    if (hashidProposal) {
      getProposalsById(hashidProposal);
    }
  }, [hashidProposal]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      size="xl"
      centered
    >
      <CardHeader>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h5>{proposal?.customer}</h5>
            <span className="text-muted fs-12">{proposal?.card_number}</span>
          </div>

          <div className="text-end">
            <p className="fw-bold text-primary">
              N° <span>{proposal?.number}</span>
            </p>
            <span className={`badge badge-soft-${proposal?.status_color}`}>
              {proposal?.status}
            </span>
          </div>
        </div>
      </CardHeader>
      <ModalBody>
        <Row>
          <h5 className="fw-bold mb-3">Detalhes da proposta</h5>
          <Col md={3} className="mt-2">
            <span className="card-label fw-bold">Categoria</span> <br />
            <span className="text-muted">{proposal?.category || '-'}</span>
          </Col>
          <Col md={3} className="mt-2">
            <span className="card-label fw-bold">Plano</span> <br />
            <span className="text-muted">{proposal?.plan || '-'}</span>
          </Col>
          <Col md={2} className="mt-2">
            <span className="card-label fw-bold">Data Venda</span> <br />
            <span className="text-muted">
              {(proposal && convertDateToBrazilFormat(proposal?.sale_at)) ||
                '-'}
            </span>
          </Col>
          <Col md={2} className="mt-2">
            <span className="card-label fw-bold">Data da Vigência</span> <br />
            <span className="text-muted">
              {(proposal &&
                convertDateToBrazilFormat(proposal?.effective_date)) ||
                '-'}
            </span>
          </Col>
          <Col md={2} className="mt-2">
            <span className="card-label fw-bold">Data da Renovação</span> <br />
            <span className="text-muted">
              {(proposal && convertDateToBrazilFormat(proposal?.valid_until)) ||
                '-'}
            </span>
          </Col>
        </Row>
        <Row>
          <Col md={3} className="mt-2">
            <span className="card-label fw-bold">Organização</span> <br />
            <span className="text-muted">
              {proposal?.organization_name || '-'}
            </span>
          </Col>
          <Col md={3} className="mt-2">
            <span className="card-label fw-bold">Lotação</span> <br />
            <span className="text-muted">{proposal?.unit_name || '-'}</span>
          </Col>
          <Col md={2} className="mt-2">
            <span className="card-label fw-bold">Situação Cadastral</span>{' '}
            <br />
            <span className="text-muted">{proposal?.status || '-'}</span>
          </Col>
          <Col md={2} className="mt-2">
            <span className="card-label fw-bold">
              Vencimento Contrato de Trabalho
            </span>{' '}
            <br />
            <span className="text-muted">
              {(proposal &&
                convertDateToBrazilFormat(
                  proposal?.work_contract_expiration
                )) ||
                '-'}
            </span>
          </Col>
          <Col md={2} className="mt-2">
            <span className="card-label fw-bold">Matrícula</span> <br />
            <span className="text-muted">{proposal?.registration || '-'}</span>
          </Col>
        </Row>
        <Row>
          <Row>
            <Col md={2} className="mt-2">
              <span className="card-label fw-bold">Assitência Funerária</span>{' '}
              <br />
              <span className="text-muted">
                {proposal?.funeral_assistance === true ? 'Sim' : 'Não' || '-'}
              </span>
            </Col>
          </Row>

          <Col md={3} className="mt-2">
            <span className="card-label fw-bold">Corretor</span> <br />
            <span className="text-muted">{proposal?.seller_name || '-'}</span>
          </Col>
          <Col md={3} className="mt-2">
            <span className="card-label fw-bold">Mensalidade</span> <br />
            <span className="text-muted">{proposal?.price || '-'}</span>
          </Col>
        </Row>

        <Row>
          <h5 className="fw-bold mt-4">Dependentes</h5>
          <Col>
            <table className="table table-nowrap">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">CPF</th>
                  <th scope="col">Nome</th>
                  <th scope="col">Nascimento</th>
                  <th scope="col">Gênero</th>
                  <th scope="col">Parentesco</th>
                  <th scope="col">Assitência Funerária</th>
                </tr>
              </thead>
              <tbody>
                {proposal?.dependents.length > 0 &&
                  proposal.dependents.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{index !== undefined ? index + 1 : ''}</td>
                        <td>{item.cpf || '-'}</td>
                        <td className="text-start">
                          <span
                            className="fw-normal"
                            style={{
                              position: 'relative',
                              bottom: 3,
                            }}
                          >
                            {item.name}
                          </span>{' '}
                          <br />
                          <span className="text-muted mt-2 fw-normal">
                            {item.card_number}
                          </span>
                        </td>
                        <td className="text-start">
                          {convertDateToBrazilFormat(item.birthdate) || '-'}
                        </td>
                        <td className="text-start">
                          {item.gender === 'M' && 'Masculino'}
                          {item.gender === 'F' && 'Feminino'}
                        </td>
                        <td className="text-start">
                          {item.kinship_name || '-'}
                        </td>
                        <td>
                          {item.funeral_assistance ? (
                            <span className="badge badge-soft-success">
                              Sim
                            </span>
                          ) : (
                            <span className="badge badge-soft-danger">Não</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Link className="btn btn-link mt-3" onClick={() => toggle()}>
          Fechar
        </Link>
        <Link
          className="btn btn-primary mt-3"
          onClick={() => history.push(`/propostas/editar/${proposal.hashid}`)}
        >
          Editar
        </Link>
      </ModalFooter>
    </Modal>
  );
};
